import { useTranslation } from "react-i18next";

import { Logo } from "@/components/base";

export const Loading: React.FC = () => {
  /**
   * This is the fallback of the Suspense that waits for translations, so it
   * must not suspend itself. Until they load, `t` returns the key.
   */
  const { t } = useTranslation(undefined, { useSuspense: false });

  return (
    <div
      role="status"
      aria-label={t("Loading")}
      className="app-root bg-background fixed inset-0 z-[100] flex items-center justify-center"
    >
      <Logo className="text-text h-16 w-auto" />
    </div>
  );
};
